import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { TableService } from '../../../../services/table.service';

import { UserService } from '../../../../services/usre.service';
import { Observable } from 'rxjs';
import { LocationService } from '../../../../services/location.service';
import { TranslateService } from '@ngx-translate/core';



@Component({
  selector: 'app-user-managment-table',
  templateUrl: './user-manegment-table.html',
  styleUrls: ['./user-manegment-table.scss']
})
export class userManagmentTable implements OnInit, OnChanges {
  ngOnChanges(changes: SimpleChanges): void {
    try {
      var reloading = changes['reload'].currentValue;
      if (reloading == true)
       console.log('')
    }
    catch{

    }

  }
  @Input() reload: Observable<boolean>;
  @Input() settings: ITabelSetttings;
  @Input() data: ITableData;
  @Output() updateUser = new EventEmitter();
  locationRoles: any[] = [];
  public pagger: number = 0;
  pagesContainer: any;
  keyword: string;
  field: string = "EmailAddress";
  role: number = 0;
  isActive: boolean = true;
  constructor(private userContext: TableService, private userService: UserService, private cdr: ChangeDetectorRef, private locationService: LocationService, private translate: TranslateService) {
    this.pagesContainer = new Array(0);
    this.locationService.getLocationRoles((res) => {
      this.locationRoles = res;

    }, (err) => { })
  }

  getItemValue(item) {
    var objectKeys = Object.keys;
    return objectKeys(item)
  }

  getIconWithRole(item: any[]) {
    var icon = ''
    for (var i = 0; i < item.length; i++) {
      this.locationRoles.forEach((r, c) => {

        if (item[i].Type == r.Type && item[i].Description.includes("Cashier"))
          icon += `<span class="armx-icon armx-cashier"></span> ${this.translate.instant('common.cashier')}`;
        else if (item[i].Type == r.Type && item[i].Description.includes("Outlet"))
          icon += `<span class="armx-icon armx-out-mgr"></span> ${this.translate.instant('common.outletManager')}`;
        else if (item[i].Type == r.Type && item[i].Description.includes("Operations"))
          icon += `<span class="armx-icon armx-operations"></span> ${this.translate.instant('common.operations')}`;
      })
    }
    return icon
  }






  prepareSearchObject(take: number, skip: number) {
    var searchObject = { skip: skip, take: take, field: this.field, startsWith: this.keyword, rolesIds: this.role, isActive: this.isActive };
    if (this.role == 0)
      delete searchObject['rolesIds'];
    if (this.keyword == '' || this.keyword == undefined) {
      delete searchObject['startsWith'];
      delete searchObject['field'];
    }
    return searchObject
  }

  getData(searchObject) {
    this.userContext.fetchData(this.settings.API.fetch,
      (res) => {
        this.data.tr = res.Results
        this.data.pageCount = res.Count
        this.pagesContainer = new Array(Math.ceil(this.data.pageCount / 10))
      },
      (err) => { console.log(err) }, searchObject);
  }

  editRow(userId) {
    this.userContext.getRow(this.settings.API.getByRow, userId, (res) => {
      this.updateUser.emit(res);
    }, (err) => { })
  }

  search() {
    this.pagger = 0;
    this.getData(this.prepareSearchObject(10, this.pagger * 10));
  }

  prevPage() {
    this.pagger--;

    this.getData(this.prepareSearchObject(10, this.pagger * 10));
  }

  nextPage() {
    this.pagger++;
    this.getData(this.prepareSearchObject(10, this.pagger * 10));
  }

  getSearchPage(pagger) {
    this.pagger = pagger;
    this.getData(this.prepareSearchObject(10, pagger * 10));

  }
  ngAfterViewInit() {
    this.cdr.detectChanges();
  }

  activateUser(event, userId) {
    this.reloading = true;
    if (event.target.checked) {
      this.userService.activateUser(userId, (res) => {
        this.getSearchPage(this.pagger);
        this.reloading = false
      }, (err) => { })
    }
    else {
      this.deactivateUser(userId);
    }
  }

  deactivateUser(userId) {
    this.reloading = true;
    this.userService.deactivateUser(userId, (res) => {
      this.reloading = false
      this.getSearchPage(this.pagger);
    }, (err) => { })
  }
  reloading = false
  ngOnInit() {
    this.reload.subscribe((x) => {
      this.reloading = false
      if (x == true) {
        this.reloading = true;
        setTimeout(() => {
          this.getSearchPage(this.pagger);
          this.reloading = false;
        }, 2000)

      }
    });
    this.getSearchPage(this.pagger);
  }

}
